import { render } from "./GenericModal.vue?vue&type=template&id=83fb74c6"
import script from "./GenericModal.vue?vue&type=script&lang=js"
export * from "./GenericModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/preflight.unbundledlegalhelp.dev.farm/releases/000000/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__